module.exports = __webpack_public_path__ + "media/images/category/dummy/shoes01-929855f7d254be77312ea9c977bb0286.jpg";